import Link from "next/link";
import { TAG_STYLE, TAG_SIZE, TAG_COLOR, TAG_TYPE, TagProps } from "./types";
import { useTagStyles } from ".";
import TagContent from "./TagContent";
import { FC } from "react";

const Tag: FC<TagProps> = (props) => {
  const {
    style = TAG_STYLE.FILL,
    size = TAG_SIZE.LARGE,
    color = TAG_COLOR.DEFAULT,
    type = TAG_TYPE.SQUARE,
    startIcon,
    endIcon,
    className,
    children,
    href,
    showTagClose = false,
    handleCloseClick,
    select,
    disableActiveClass = false,
    ...otherProps
  } = props;

  const classNames = useTagStyles(props);

  const content = (
    <TagContent
      size={size}
      startIcon={startIcon}
      endIcon={endIcon}
      showTagClose={showTagClose}
      handleCloseClick={handleCloseClick}
    >
      {children}
    </TagContent>
  );

  if (href) {
    const { target } = otherProps as any;

    return (
      <Link
        href={href}
        className={classNames}
        target={target || "_self"}
        {...(otherProps as any)}
      >
        {content}
      </Link>
    );
  }

  return (
    <button className={classNames} {...(otherProps as any)}>
      {content}
    </button>
  );
};

export default Tag;
